import { useState } from "#imports";
export function definePageLanguageLinks(path, links) {
  const statePath = useState("pageLanguageLinksPath", () => "");
  const stateLinks = useState("pageLanguageLinksLinks", () => ({}));
  statePath.value = path;
  stateLinks.value = links;
}
